function calculateProgress(currentVal, targetVal) {
  var wrapper = document.querySelectorAll(".cart-shipping__wrapper");

  var textField = document.querySelectorAll(".cart-shipping__text");
  // calculate how far progress is from the total as a percentage

  // Update the progess text. If threshold is met, show success message
  var newProgressNum = (targetVal - currentVal) / 100;
  if (newProgressNum <= 0) {
    wrapper.forEach(function (el) {
      el.style.backgroundColor = "#DEF7EC";
    });
    textField.forEach(function (el) {
      el.textContent = "Du har opnået gratis fragt";
    });
  } else {
    wrapper.forEach(function (el) {
      el.style.backgroundColor = "#FDF2F2";
    });
    textField.forEach(function (el) {
      el.textContent = `Køb for ${newProgressNum} kr. mere for at få gratis fragt`;
    });
  }
}
fetch("/cart.js")
  .then((response) => response.json())
  .then((data) => {
    calculateProgress(data.total_price, 59900);
  });
